import { PrimaryButton as Button } from '@shape-ds/components';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { InfoMessage } from '@shape/lighthouse-components';
import axios from 'axios';
import { useQueryClient } from '@tanstack/react-query';

export const InterceptedAPIStatus = [403];

export const ApiErrorFallback = ({ resetErrorBoundary, error }: FallbackProps) => {
  const { t } = useTranslation();
  const isAxiosError = axios.isAxiosError(error);
  const queryClient = useQueryClient();

  if (!isAxiosError || !error.status || !InterceptedAPIStatus.includes(error.status)) {
    throw error;
  }

  return (
    <div className="columns is-centered">
      <div className="column  has-text-centered mt-4" role="alert">
        <InfoMessage
          type="error"
          title={t(`messages:api_errors.${error.status}.title`)}
          message={t(`messages:api_errors.${error.status}.message`)}
        />
        <Button
          onClick={() => {
            resetErrorBoundary();
            queryClient.resetQueries();
          }}
          className="mt-3"
        >
          {t('glossary:tryAgain')}
        </Button>
      </div>
    </div>
  );
};
